import type { Transaction, TransactionWrite } from '../../lib/api-types';

export function transactionToWrite(
  transaction: Transaction,
  patch: Partial<TransactionWrite> = {},
): TransactionWrite {
  return {
    active: transaction.active,
    amount: transaction.amount,
    categoryId: transaction.categoryId,
    date: transaction.date,
    frequency: transaction.frequency,
    limitDate: transaction.limitDate,
    note: transaction.note,
    toWalletId: transaction.toWalletId,
    type: transaction.type,
    walletId: transaction.walletId,
    ...patch,
  };
}
